export default "__VITE_ASSET__BPYvPCPi__$_?nuxt_component=async&nuxt_component_name=SvgoLogo&nuxt_component_export=default__"